import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import ProductPublishEditor from '@/shein-platform/modules/products/ProductPublishEditor';

/** 编辑商品：审核中优先靠本地草稿/发布记录回填 */
export default function ProductEditPage() {
  const { spuName: spuFromPath } = useParams();
  const [params] = useSearchParams();
  const spuName = decodeURIComponent(spuFromPath || params.get('spu') || '');
  const recordId = params.get('recordId') || '';
  const draftId = params.get('draftId') || '';

  return (
    <ProductPublishEditor
      mode="edit"
      spuName={spuName}
      recordId={recordId}
      draftId={draftId}
    />
  );
}
